import React, { useState, useEffect } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { CONVO_SEARCH, ALL_EMAIL_CONVOS } from 'graphql/conversations';
import Messages from './Messages';
import { Subscription } from 'react-apollo';
import Search from 'components/common/Search';
import Conversation from '../components/Conversation';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CreateIcon from '@material-ui/icons/Create';
import Drawer from '@material-ui/core/Drawer';
import Checkbox from '@material-ui/core/Checkbox';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import NewConversation from '../components/NewConversation';
import { useSelector } from 'react-redux';
import { ROLES } from '../../../../constant/userTypes';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const EmailInbox = (props) => {
  const { history } = props;
  const [inputVal, setInputVal] = useState('');
  const [showNewConvo, setShowConvo] = useState(false);
  const [offset, setOffset] = useState(0);
  const user = useSelector((s) => s.user.user);
  const [query, setQuery] = useState();
  const [allChannels, setAllChannels] = useState(false);
  const [archived, setArchived] = useState(false);

  const toggleNewConvo = () => {
    setShowConvo(!showNewConvo);
  };

  useEffect(() => {
    setOffset(0);
    if (!inputVal && query) {
      setQuery();
    }
  }, [inputVal]);

  useEffect(() => {
    setQuery('');
    setOffset(0);
  }, [allChannels]);

  const onSearch = () => {
    if (!inputVal) {
      setQuery();
    } else {
      setQuery(`%${inputVal}%`);
    }
  };

  const onNext = () => {
    setOffset(offset + 20);
  };

  const onPrev = () => {
    setOffset(offset - 20);
  };

  const variables = {
    match: query || undefined,
    type: 'email',
    offset,
    userId: !allChannels ? user.id : undefined,
    archived: archived ? {_eq: true } : { _neq: true}
  };

  return (
    <div>
      <Subscription
        subscription={allChannels ? ALL_EMAIL_CONVOS : CONVO_SEARCH}
        variables={variables}
      >
        {({ data, loading, error }) => {

          if (error) {
            return error.message;
          }

          return (
            <>
              <Grid container justify="space-between">
                <Grid item md={6}>
                  <Search
                    placeholder="Search..."
                    inputVal={inputVal}
                    onChange={setInputVal}
                    onSearch={onSearch}
                  />
                  <Box>
                    {user.type === ROLES.ADMIN && (
                      <FormControlLabel
                        value={true}
                        checked={allChannels}
                        onChange={(e) => setAllChannels(e.target.checked)}
                        control={<Checkbox color="primary" />}
                        label="Show All Emails"
                        labelPlacement="end"
                      />
                    )}
                    <FormControlLabel
                      value={true}
                      checked={archived}
                      onChange={(e) => setArchived(e.target.checked)}
                      control={<Checkbox color="primary" />}
                      label="Show Archived Emails"
                      labelPlacement="end"
                    />
                  </Box>
                </Grid>
                <Grid item md={4}>
                  <Box textAlign="right">
                    <Button
                      startIcon={<CreateIcon />}
                      size="large"
                      variant="contained"
                      color="primary"
                      onClick={toggleNewConvo}
                    >
                      New Conversation
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              <Switch>
                <Route
                  path="/inbox/:type/:id"
                  render={() => (
                    <IconButton component={Link} to="/inbox/email">
                      <ChevronLeftIcon />
                    </IconButton>
                  )}
                />
                <Grid container justify="flex-end">
                  <Grid item>
                    <IconButton disabled={offset < 1} onClick={onPrev}>
                      <ChevronLeftIcon />
                    </IconButton>
                    <IconButton
                      disabled={data?.conversations.length !== 20}
                      onClick={onNext}
                    >
                      <ChevronRightIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Switch>
              <Switch>
                <Route path="/inbox/:type/:id" component={Conversation} />
                <Messages
                  loading={loading}
                  {...props}
                  conversations={data?.conversations}
                />
              </Switch>
            </>
          );
        }}
      </Subscription>
      <Drawer
        anchor="right"
        disableBackdropClick
        open={showNewConvo}
        onClose={toggleNewConvo}
        ModalProps={{
          disableAutoFocus: true,
          disableEnforceFocus: true,
        }}
      >
        <NewConversation
          onClose={toggleNewConvo}
          type="email"
          user={user}
          history={history}
        />
      </Drawer>
    </div>
  );
};

export default EmailInbox;
